module.exports = __webpack_public_path__ + "img/add_btn_icon461.fdf4ce9a.svg";